import { Typography, Link, Box } from '@mui/material';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const KnowledgeBase = () => {
  useEffect(() => {
    setTimeout(() => {
      window.open(import.meta.env.VITE_WB_KNOWLEDGE_BASE_URL);
    }, 500);
  }, []);

  return (
    <Box
      sx={{
        borderRadius: '8px',
        border: '1px solid rgba(0, 0, 0, 0.16)',
        maxHeight: '551px',
        padding: 3,
        bgcolor: '#FFF',
      }}
    >
      <Typography component='div'>
        <Link
          href={import.meta.env.VITE_WB_KNOWLEDGE_BASE_URL}
          target='_blank'
          color='#00CECF'
        >
          <FormattedMessage defaultMessage='Click here' />
        </Link>{' '}
        <FormattedMessage defaultMessage="if the page doesn't open automatically" />
      </Typography>
    </Box>
  );
};

export default KnowledgeBase;
